import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react';
import cn from 'classnames';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import { EventType, NotificationType } from 'globals/types';
import FsEventsFeedIconLoader from 'ui-elements/image-loaders/FsEventsFeedIconLoader';
import FsDate from 'ui-elements/common-elements/FsDate';
import {
  ContainerBox,
  Description,
  IconWrapperBox,
  Name,
  ReferenceLabel,
  ReferenceBox,
  ReferenceValue,
} from './SingleNotificationItem.style-elements';

export interface SingleNotificationItemDataProps {
  id: number;
  eventType: EventType;
  notificationType: NotificationType;
  name: string;
  timestamp: number;
  reference: string;
  description: string;
  isRead: boolean;
  reportId: number;
}

export interface SingleNotificationItemProps
  extends SingleNotificationItemDataProps {
  onClick?: () => void;
}

const SingleNotificationItem: React.FC<SingleNotificationItemProps> = ({
  eventType,
  name,
  timestamp,
  reference,
  description,
  isRead,
  reportId,
  onClick,
  id,
}) => {
  const {
    notifications: { update: updateNotificationList },
  } = useAppContext();
  const history = useHistory();
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const handleClick = async () => {
    setIsClicked(true);
    // eslint-disable-next-line no-console
    console.log('SEND', id); // TODO: POST REQUEST (UPDATE isReadState)
    await wait(50);
    await history.push(`${Routes.REPORT}/id/${reportId}`);
    await updateNotificationList();
    if (onClick) onClick();
  };

  return (
    <ContainerBox onClick={handleClick} className={cn({ isClicked, isRead })}>
      <IconWrapperBox>
        <FsEventsFeedIconLoader type={eventType} />
      </IconWrapperBox>
      <Box>
        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="space-between"
        >
          <Box mr={2}>
            <Name>{name}</Name>
          </Box>
          <FsDate date={timestamp} withTime withYear />
        </Box>
        <ReferenceBox>
          <ReferenceLabel>{defaultLocales.reference}</ReferenceLabel>
          <ReferenceValue>{reference}</ReferenceValue>
        </ReferenceBox>
        <Description>{description}</Description>
      </Box>
    </ContainerBox>
  );
};

export default observer(SingleNotificationItem);
